// Configuration for Commander PSIM Web Application

// Detect if running in Tauri - check multiple ways
function checkIsTauri(): boolean {
  if (typeof window === 'undefined') return false;

  // Method 1: Check for __TAURI__ global
  if ('__TAURI__' in window) return true;

  // Method 2: Check for tauri:// protocol
  if (window.location.protocol === 'tauri:') return true;

  // Method 3: Check for https://tauri.localhost origin (Tauri v2 uses this)
  if (window.location.origin.includes('tauri.localhost')) return true;

  // Method 4: Check if not running on a web server (file:// or custom protocol)
  if (window.location.protocol !== 'http:' && window.location.protocol !== 'https:') return true;

  return false;
}

// Log detection result on load
if (typeof window !== 'undefined') {
  console.log('[Config] Tauri detection:', {
    isTauri: checkIsTauri(),
    protocol: window.location.protocol,
    origin: window.location.origin,
    hasTauriGlobal: '__TAURI__' in window
  });
}

// Get API base URL - evaluated at call time to ensure Tauri is detected
export function getApiBaseUrl(): string {
  const isTauri = checkIsTauri();
  const url = isTauri ? 'http://localhost:4000/api/v1' : '/api/v1';
  return url;
}

// For backward compatibility - evaluated immediately but also re-checked on use
export const API_BASE_URL = checkIsTauri()
  ? 'http://localhost:4000/api/v1'
  : '/api/v1';

// WebSocket URL
export const WS_BASE_URL = checkIsTauri()
  ? 'ws://localhost:4000'
  : '';

export const config = {
  get apiBaseUrl() { return getApiBaseUrl(); },
  get wsBaseUrl() { return checkIsTauri() ? 'ws://localhost:4000' : ''; },
  get isTauri() { return checkIsTauri(); },
};
